// State
export const state = () => ({
    loading: false,
    withdrawalExistingData: {},
    createWithdrawalLoading: false,
    createCryptoWithdrawalLoading: false,
    withdrawEventsBody: {},
})

// Actions
export const actions = {
    // Get check withdrawal
    async checkExistWithdrawal({ commit }) {
        commit('setLoading', true)
        this.commit('settings/setCancelToken', {
            existWithdraw: this.$axios.CancelToken.source(),
        })
        try {
            const response = await this.$axios.get(
                '/withdrawals/check/is-exists',
                {
                    cancelToken:
                        this.state.settings.cancelToken.existWithdraw.token,
                }
            )
            commit('setWithdrawalExistingData', response.data)
            commit('setLoading', false)
            return response.data
        } catch (error) {
            commit('setLoading', false)
            return {}
        }
    },
    // Create withdraw
    async createWithdraw({ commit, state }, form) {
        commit('setLoading', true)
        commit('setCreateWithdrawalLoading', true)
        const data = { ...form }
        if (state?.withdrawEventsBody?.px_id) {
            data.event_data = { ...state.withdrawEventsBody }
        }
        try {
            const response = await this.$axios.post('/withdrawals', data)
            return response.data
        } catch (error) {
        } finally {
            commit('setLoading', false)
            commit('setCreateWithdrawalLoading', false)
        }
    },
    // Cancel withdraw
    async cancelWithdraw({ commit }, id) {
        commit('setLoading', true)
        try {
            const response = await this.$axios.put(
                '/withdrawals/cancel/' + id,
                {}
            )
            return response.data
        } catch (error) {
        } finally {
            commit('setLoading', false)
        }
    },
    async createCryptoWithdrawal({ commit, state }, form) {
        commit('setLoading', true)
        commit('setCreateCryptoWithdrawalLoading', true)
        const data = { ...form }
        if (state?.withdrawEventsBody?.px_id) {
            data.event_data = { ...state.withdrawEventsBody }
        }
        try {
            const response = await this.$axios.post('/withdrawals/crypto', data)
            return response.data
        } catch (error) {
        } finally {
            commit('setLoading', false)
            commit('setCreateCryptoWithdrawalLoading', false)
        }
    },
}

// Mutations
export const mutations = {
    setLoading(state, data) {
        state.loading = data
    },
    setWithdrawalExistingData(state, data) {
        state.withdrawalExistingData = data
    },
    setCreateWithdrawalLoading(state, data) {
        state.createWithdrawalLoading = data
    },
    setCreateCryptoWithdrawalLoading(state, data) {
        state.createCryptoWithdrawalLoading = data
    },
    setWithdrawEventsBody: (state, data) => {
        state.withdrawEventsBody = data
    },
}

// Getters
export const getters = {}
